import {Button} from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import {
  makeStyles,
  createStyles,
  withStyles,
} from "@material-ui/core/styles";
import LinearProgress from "@material-ui/core/LinearProgress";
import { useHistory } from "react-router-dom";

const BorderLinearProgress = withStyles(() =>
  createStyles({
    root: {
      height: 10,
      borderRadius: 5
    },
    colorPrimary: {
      backgroundColor:"#fff",
    },
    bar: {
      borderRadius: 20,
      backgroundColor: "#FF5964"
    }
  })
)(LinearProgress);
const useStyles = makeStyles(() => ({
  parentRoot:{
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
  root: {
    flexGrow: 1,
    border: "1px solid #D9DEE3",
    maxWidth: "300px",
    width: "100%",
    borderRadius: "20px",
    "& .MuiLinearProgress-root":{
      height: 20,
      borderRadius: "20px",
      transform: "rotate(180deg)",
    }
  },
  viewPlan: {
    fontFamily: 'roboto-regular',
    marginLeft: 5,
    marginRight: 5,
    whiteSpace: 'nowrap',
    padding: '0 20px'
  },
  btn: {
    height: 37,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 14,
    margin: "0 0 0 20px",
    lineHeight:'18px',
    '@media screen and (max-width: 1267px)': {
      margin: 0,
    },
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  trialTxt:{
    marginRight: "55px",
    color: '#697683',
    fontSize: "20px",
    whiteSpace: "nowrap",
    '@media screen and (max-width: 1267px)': {
      marginRight: 12,
    },
  },
  trialBanner:{
    background:'#e4e9ef',
    padding: '10px 38px',
    marginLeft:'65px',
    boxShadow:"0px 0px 0px 0px rgb(0 0 0 / 20%), 0px 0px 0px 0px rgb(0 0 0 / 14%), 0px 1px 0px 0px rgb(0 0 0 / 12%)",
    "& p":{
      margin:0,
      maxWidth: '370px',
      width: '100%',
      color: "#697683",
      fontSize: 14,
    },
    '@media screen and (max-width: 1267px)': {
      padding: '10px',
    },
    '@media screen and (max-width: 959px)': {
      marginLeft: 0,
    },
  },
  dayLeft:{
    display: "block",
    color: "#FF5964",
    fontSize: 14,
    margin: "0 0 0 10px",
    whiteSpace: 'nowrap'
  },
  headRight:{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    '& p':{
      fontSize: 14,
      marginLeft: 12,
      '@media screen and (max-width: 1267px)': {
        fontSize: 11,
      },
      '@media screen and (max-width: 927px)': {
        display:'none',
      },
    }
  },
  trialwrapper:{
    display:"flex",
    '@media screen and (max-width: 599px)': {
      flexDirection:'column'
    },
  }
}));

function trialBanner(props:any) {
  const {daysLeft,billingDetails} = props;
  const billing_period = billingDetails.billing_period?parseInt(billingDetails.billing_period):0
  const classes = useStyles();
  const history = useHistory();
  const progressPercentage = daysLeft*100/billing_period

  const goToBilling = ()=>{
    history.push("/subscriber/admin/billing");
  }

  return (
    <div className={classes.trialBanner}>
       <Grid container direction="row" alignItems="center" justifyContent="flex-start">
           <Grid className={classes.trialwrapper}  item xs={6}>
            <span className={classes.trialTxt}>Free Trial</span>
            <div className={classes.parentRoot}>
              <div className={classes.root}>
                <BorderLinearProgress variant="determinate" value={progressPercentage} />
              </div>
              <span className={classes.dayLeft}>{daysLeft} days left</span>
            </div>
          </Grid>
          <Grid item xs={6} className={classes.headRight}>
            <p>Keep access to your measurements.<br/> Most plans have no caps on participants or measurements.</p>
            <Button
              color='primary'
              className={classes.btn}
              onClick={goToBilling}
            >
              <span className={classes.viewPlan}>View Paid Plans</span>
            </Button>
          </Grid>
        </Grid>
    </div>
  );
}

export default trialBanner;